import {yupResolver} from '@hookform/resolvers/yup'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {ReactElement} from 'react'
import {useMemo} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

import {Form} from './components/form/Form@desktop'
import {useDefaultValuesAndDraftSync} from './components/form/hooks/use-default-values-and-draft-sync'
import {ConfigProvider} from './contexts'
import {getFormValidationSchema} from './lib/validation'
import * as classes from './OrderForm@desktop.classes'
import type {OrderFormProps, OrderFormState} from './types'

export function OrderForm(props: OrderFormProps): ReactElement {
  const {config} = props
  const i18n = useI18n()
  const {defaultValues} = useDefaultValuesAndDraftSync(config)

  const resolver = useMemo(
    () =>
      yupResolver(
        getFormValidationSchema(i18n, config),
        {},
        {
          mode: 'async',
        },
      ),
    [i18n, config],
  )

  const form = useForm<OrderFormState>({
    defaultValues,
    resolver,
    mode: 'onBlur',
  })

  return (
    <>
      <div className={classes.root}>
        <div className={classes.formWrapper}>
          <div className={classes.form} data-e2e="full-form">
            <ConfigProvider {...config}>
              <FormProvider {...form}>
                <Form />
              </FormProvider>
            </ConfigProvider>
          </div>
        </div>
      </div>
    </>
  )
}
